import React, { useState, useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Sparkles, Heart, CheckCircle2 } from 'lucide-react';
export function EarlyAccessSection() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [donationAmount, setDonationAmount] = useState<number>(0);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const cardY = useTransform(scrollYProgress, [0, 1], [60, -40]);
  const blobY = useTransform(scrollYProgress, [0, 1], [-40, 80]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', {
      name,
      email,
      donationAmount
    });
    setIsSubmitted(true);
  };
  const donationOptions = [0, 5, 10, 25];
  return <section ref={sectionRef} id="aanmelden" className="py-20 lg:py-32 bg-white relative overflow-hidden" data-id="element-189">
      <motion.div style={{
      y: blobY
    }} className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-orange-300/15 blur-[100px] pointer-events-none" data-id="element-190" />
      <motion.div style={{
      y: cardY
    }} className="absolute top-[10%] right-[-15%] w-[40%] h-[40%] rounded-full bg-amber-300/15 blur-[100px] pointer-events-none" data-id="element-191" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-192">
        <div className="bg-[#FFF9F2] rounded-[3rem] p-8 md:p-16 shadow-2xl border border-orange-100" data-id="element-193">
          {!isSubmitted ? <div className="max-w-2xl mx-auto" data-id="element-194">
              <div className="text-center mb-10" data-id="element-195">
                <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-600 px-4 py-2 rounded-full font-bold text-sm mb-6" data-id="element-196">
                  <Sparkles className="w-4 h-4" data-id="element-197" />
                  Release Candidate
                </div>
                <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-6 tracking-tight" data-id="element-198">
                  Wees er als <br data-id="element-199" />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-amber-500" data-id="element-200">
                    eerste bij
                  </span>
                </h2>
                <p className="text-lg text-slate-600 font-medium" data-id="element-201">
                  We leggen de laatste hand aan Meester djay. Meld je nu aan en
                  krijg <strong data-id="element-202">6 maanden gratis</strong> bij de lancering — als
                  klein bedankje dat je vroeg meedoet.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-203">
                <div className="grid md:grid-cols-2 gap-6" data-id="element-204">
                  <div data-id="element-205">
                    <label htmlFor="name" className="block text-sm font-bold text-slate-700 mb-2" data-id="element-206">
                      Naam ouder
                    </label>
                    <input type="text" id="name" required value={name} onChange={e => setName(e.target.value)} className="w-full border-2 border-slate-200 rounded-2xl px-4 py-3 bg-white focus:outline-none focus:ring-2 focus:ring-orange-200 focus:border-orange-400 font-medium text-slate-900 placeholder:text-slate-400 transition-colors" placeholder="Voor- en achternaam" data-id="element-207" />
                  </div>
                  <div data-id="element-208">
                    <label htmlFor="email" className="block text-sm font-bold text-slate-700 mb-2" data-id="element-209">
                      E-mailadres
                    </label>
                    <input type="email" id="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full border-2 border-slate-200 rounded-2xl px-4 py-3 bg-white focus:outline-none focus:ring-2 focus:ring-orange-200 focus:border-orange-400 font-medium text-slate-900 placeholder:text-slate-400 transition-colors" placeholder="jouw@email.nl" data-id="element-210" />
                  </div>
                </div>

                <div className="pt-6 border-t border-orange-200/50" data-id="element-211">
                  <label className="block text-sm font-bold text-slate-700 mb-4 text-center" data-id="element-212">
                    Wil je de ontwikkeling steunen met een kleine donatie?
                    (Optioneel)
                  </label>
                  <div className="flex flex-wrap justify-center gap-3" data-id="element-213">
                    {donationOptions.map(amount => <button key={amount} type="button" onClick={() => setDonationAmount(amount)} className={`px-6 py-3 rounded-2xl font-bold transition-all ${donationAmount === amount ? 'bg-orange-500 text-white shadow-[0_4px_0_0_rgb(194,65,12)] translate-y-[-2px]' : 'bg-white text-slate-600 border-2 border-slate-200 hover:border-orange-300 hover:text-orange-500'}`} data-id="element-214">
                        {amount === 0 ? 'Nee, bedankt' : `€${amount}`}
                      </button>)}
                  </div>
                </div>

                <div className="pt-8" data-id="element-215">
                  <button type="submit" className="w-full flex justify-center items-center gap-2 bg-orange-500 text-white shadow-[0_4px_0_0_rgb(194,65,12)] hover:bg-orange-400 hover:-translate-y-0.5 active:translate-y-[2px] active:shadow-none rounded-2xl font-bold px-8 py-4 transition-all text-lg" data-id="element-216">
                    Meld je aan voor vroege toegang
                    {donationAmount > 0 && <Heart className="w-5 h-5 fill-current" data-id="element-217" />}
                  </button>
                  <p className="text-center text-sm text-slate-500 mt-4 font-medium" data-id="element-218">
                    Geen spam, we sturen je alleen een mailtje als we lanceren.
                  </p>
                </div>
              </form>
            </div> : <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="text-center py-12" data-id="element-219">
              <div className="w-24 h-24 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-220">
                <CheckCircle2 className="w-12 h-12 text-emerald-500" data-id="element-221" />
              </div>
              <h3 className="text-3xl font-black text-slate-900 mb-4" data-id="element-222">
                Je staat op de lijst! 🎉
              </h3>
              <p className="text-lg text-slate-600 font-medium max-w-md mx-auto" data-id="element-223">
                Bedankt voor je aanmelding
                {donationAmount > 0 ? ' en je donatie' : ''}! We houden je op de
                hoogte van de lancering.
              </p>
            </motion.div>}
        </div>
      </div>
    </section>;
}